export default __webpack_public_path__ + "static/media/040_tunnel.e24ceddc.mp3";